import React, { useState, useEffect } from 'react';
import { Card, Tag, Image } from 'antd';

const UserCard = ({ user }) => {
  const [imgSrc, setImgSrc] = useState("");
  
  useEffect(() => {
    try {
      if (user && user.img) {
        // 确保 img 是字符串类型
        const img = String(user.img);
        
        if (img.startsWith('blob:') || 
            img.startsWith('data:') || 
            img.startsWith('http') || 
            img.includes("/api/files")) {
          // 已经是有效的格式
          setImgSrc(img);
        } else {
          // 处理相对路径格式
          setImgSrc(`http://www.9ha.top${img}`);
        }
      } else {
        setImgSrc("");
      }
    } catch (error) {
      console.error("处理图片时出错:", error);
      setImgSrc("");
    }
  }, [user?.img]);  // 使用可选链确保安全

  return (
    <div className="breathe card-enter animate-element">
      <Card
        title={
          <>
            <Tag color="blue">{user?.tag || "默认标签"}</Tag>
            <span style={{ marginLeft: 7 }}>
              {user.name}
            </span>
          </>
        }
        cover={
          <div style={{ padding: 5 }}>
            {imgSrc ? (
              <img 
                src={imgSrc} 
                alt={user?.name || "用户图片"} 
                style={{ 
                  width: '100%', 
                  maxWidth: '100%',
                  height: 'auto',
                  borderRadius: 4 
                }}
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjYWFhIiBmb250LXNpemU9IjE2Ij5ObyBJbWFnZTwvdGV4dD48L3N2Zz4=';
                }}
              />
            ) : (
              <div style={{ 
                width: '100%', 
                height: '200px', 
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#aaa'
              }}>
                暂无图片
              </div>
            )}
          </div>
        }
      >
        <div style={{ marginBottom: 8 }}>
          <strong>段位: </strong>
          <Tag color="purple">{user?.level || "无段位信息"}</Tag>
        </div>
        <p>{user?.text}</p>
      </Card>
    </div>
  );
};

export default UserCard;
